<template>
  <div class="next-draws-filter">
    <div class="date-selector">
      <input 
        type="date" 
        :value="modelValue"
        :min="allowPast ? null : today"
        @change="handleInput"
        class="date-input"
      >
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'NextDrawsFilter'
}
</script>
<script setup lang="ts">
import { defineEmits, defineProps, withDefaults } from 'vue';

const props = withDefaults(defineProps<{
  modelValue?: string;
  allowPast?: boolean;
}>(), {
  modelValue: () => new Date().toISOString().split('T')[0],
  allowPast: false
});

const today = new Date().toISOString().split('T')[0];

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.value || today);
};
</script>

<style scoped>
.next-draws-filter {
  display: flex !important;
  justify-content: center !important;
  margin-bottom: 0;
  flex: 1;
  align-items: center;
}

.date-selector {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  z-index: 1;
}

/* Mobile: Full width and match LotteryFilters height */
@media (max-width: 768px) {
  .next-draws-filter {
    justify-content: stretch !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  
  .date-selector {
    width: 100%;
    max-width: 100%;
    flex: 1;
  }
  
  .date-input {
    height: 35.549530029296875px !important;
    /* padding: 8px 40px 8px 10px !important; */
    font-size: 13px !important;
    border-radius: 7.91px !important;
    border-width: 1.58px !important;
  }
  
  .date-input::-webkit-calendar-picker-indicator {
    right: 10px !important;
    width: 16px !important;
    height: 16px !important;
  }
}

.date-input {
  width: 100%;
  background: var(--bg-filter-select, var(--bg-secondary));
  border-radius: 12px;
  border: 2px solid var(--border-color);
  color: var(--text-primary);
  font-size: 14px;
  padding: 20px 50px 20px 20px;
  cursor: pointer;
  outline: none;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  height: 60px;
}

.date-input::-webkit-calendar-picker-indicator {
  filter: invert(0) sepia(0) saturate(0) hue-rotate(0deg) brightness(0.2) contrast(1) !important;
  cursor: pointer;
  opacity: 1;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  margin: 0;
}
</style>
